<template>

  <a-card :bordered="false">
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="二维码号" name='code_sn'>
        <a-input style="width: 270px" v-model:value="search.code_sn" placeholder="请输入关键词进行搜索" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table class='m-t-25' :pagination='false' :loading='loading' bordered rowKey='product_sn' :columns='columns' :data-source='orderData.code_list'>
      <template v-slot:code_sn="{ record }">
        <a href="javascript:;" v-has:antiAuditQuery='()=>{$router.push("/antiFleeingGoods/marketAudit/tracking?code="+record.code_sn)}'>{{record.code_sn}}</a>
      </template>
      <template v-slot:gift_name="{ record }">
        <a-card-meta>
          <template #avatar>
            <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
          </template>
          <template #description>
            <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
          </template>
        </a-card-meta>
      </template>
      <!-- <template v-slot:action="{ record }">
        <a-button type="link" @click='goodsItem = record.product[0];showCode = true;'>查看出货二维码</a-button>
      </template> -->
    </a-table>
  </a-card>
  <!-- <a-modal :keyboard="false" title="出货二维码" :width='1300' centered v-model:visible="showCode" destroyOnClose :footer='null'>
    <shippingCode :id='goodsItem.product_id' :showLast='true' :sn='$route.query.id' :sku_sn='goodsItem.product_sku_sn' type='outbound'></shippingCode>
  </a-modal> -->
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs, h } from "vue";
import { message } from "ant-design-vue";
import store from "@/store";
// import shippingCode from "../../components/shippingCode.vue";
import { getOutWarehousingMore, closeRefundOrder } from "@/api/antiFleeing";
import { iscode } from "@/utils/app";
export default {
  components: {  },
  props: { id: String },
  setup(props) {
    const search = ref({
      page: 1,
      limit: 10,
      code_sn: "",
    });
    const state = reactive({
      info: store.state.user.info,
      orderData: {},
      goodList: [],
      loading: false,
      showCode: false,
      goodsItem: {},
      historyLength: 0,
      columns: [
        {
          title: "二维码号",
          dataIndex: "code_sn",
          key: "code_sn",
           slots: { customRender: "code_sn" },
        },
        {
          title: "二维码类型",
          dataIndex: "code_type_text",
          key: "code_type_text"
        },
        {
          title: "商品名称",
          dataIndex: "product_sku_name",
          key: "product_sku_name",
          slots: { customRender: "gift_name" },
        },
        {
          title: "商品规格",
          dataIndex: "out_warehousing_num",
          key: "out_warehousing_num",
          customRender: ({ record }) => {
            return (record.product_sku_name&&record.product_sku_name!='0') ? record.product_sku_name : "单规格";
          },
        },
        {
          title: "商品数量",
          dataIndex: "code_num",
          key: "code_num",
        },
        {
          title: "入库仓库",
          dataIndex: "out_warehousing_real_num",
          key: "out_warehousing_real_num",
          customRender: ({ record }) => {
            return record.warehouse_position_name || "-";
          },
        },
      ],
    });
    //获取详情
    const initData = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res = await getOutWarehousingMore(props.id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        // if (
        //   (res.data.out_warehousing_status == 3 ||
        //     res.data.out_warehousing_status == 2) &&
        //   !state.columns.find((v) => v.title == "操作")
        // ) {
        //   state.columns.push({
        //     title: "操作",
        //     key: "action",
        //     slots: { customRender: "action" },
        //   });
        // }
        state.orderData = res.data;
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    };
    onMounted(() => {
      initData();
      state.historyLength = window.history.length;
    });
    return {
      ...toRefs(state),
      search,
    };
  },
};
</script>